import async from 'async';
import utils from '@/utils';

const find = (commit, callback) => {
  utils.send({
    path: '/personal/find',
    callback(data) {
      commit('loadForm', data.item)
      callback(null);
    },
  });
};

export default {
  updateItem: ({ state, commit }, form) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/personal/update',
          options: {
            name: form.name,
            email: form.email,
          },
          callback(data) {
            utils.success('personalUpdate');
            next(null);
          },
        });
      },
      (next) => { find(commit, next) },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  loadForm: ({ state, commit }) => {
    find(commit, (err) => {
      if (err) {
        utils.error('illegal');
      }
    })
  },
};
